import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Sessione scaduta: invece di buttare fuori l'utente (e fargli perdere il lavoro non salvato)
// si chiede di nuovo la password in una finestra sopra la pagina e poi si ripete la richiesta fallita.
let reloginPromise = null;
function requestRelogin() {
  if (!reloginPromise) {
    reloginPromise = new Promise((resolve, reject) => {
      window.dispatchEvent(new CustomEvent('session-expired', { detail: { resolve, reject } }));
    });
    const clear = () => { reloginPromise = null; };
    reloginPromise.then(clear, clear);
  }
  return reloginPromise;
}

export function hardLogout() {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('auth_user');
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    const isAuthEndpoint = url.includes('/auth/login') || url.includes('/auth/forgot-password') || url.includes('/auth/reset-password');
    // Only handle expired/invalid sessions on protected endpoints,
    // never on the login flow (so the form can display "Credenziali non valide").
    if (error.response?.status === 401 && !isAuthEndpoint) {
      const cfg = error.config;
      if (cfg && !cfg.__relogged && window.__sessionDialogReady && localStorage.getItem('auth_token')) {
        cfg.__relogged = true;
        return requestRelogin().then(
          () => {
            cfg.headers = cfg.headers || {};
            cfg.headers.Authorization = `Bearer ${localStorage.getItem('auth_token')}`;
            return api(cfg);
          },
          () => Promise.reject(error)
        );
      }
      hardLogout();
    }
    return Promise.reject(error);
  }
);

// Rinnova il token mentre si lavora, cosi' la sessione non scade a meta' di un lavoro.
export async function refreshSessionToken() {
  if (!localStorage.getItem('auth_token')) return;
  const res = await api.post('/auth/refresh');
  if (res.data?.token) localStorage.setItem('auth_token', res.data.token);
}

export default api;
